let tbLayerList = [];
let originProjection = null;


//使用threebox图层时自适应切换到mercator投影
export function setMercator(map, tbLayerId) {
    // 记录原投影
    if(tbLayerList.length===0) {
        originProjection = map.getProjection();
        if(originProjection.name !== 'mercator'){
            // threebox图层需要平面才能正常展示，将地图转化成墨卡托投影的平面
            map.setProjection('mercator');
        }
    }
    tbLayerList.push(tbLayerId);
}


//不再有threebox图层时，切换回原投影
export function setOriginProjection(map, tbLayerId) {
    tbLayerList = tbLayerList.filter(element => element !== tbLayerId);
    if(tbLayerList.length===0) {
        // 将投影变换为原投影
        map.setProjection(originProjection);
    }
}


//在setWindowTb中挂载window全局tb，供后续three.js代码（three.js中使用全局的tb变量）使用
export function setWindowTb(tb) {
    // 此处定义window挂载全局tb，供后续three.js代码使用
    window.tb = tb;
}

